import React from 'react';
import { injectIntl } from 'react-intl';
import { Descriptions } from 'antd';
import PropTypes from 'prop-types';
import { getJobMessages } from '../../../../constants/messages';
import { getNestedValue } from '../../../../utilities/util';
import Embolden from '../../../GlobalComponents/Embolden';
import { SearchAvailableDevices, SearchAvailableSimCards } from '../../actions';
import Description from '../../AddUpdateJob/CommonComponents/Description';
import Device from '../../AddUpdateJob/CommonComponents/Device';
import DeviceAccessoriesIntermediator from '../../AddUpdateJob/CommonComponents/DeviceAccessoriesIntermediator';
import DeviceLease from '../../AddUpdateJob/CommonComponents/DeviceLease';
import Icon from '../../AddUpdateJob/CommonComponents/Icon';
import Sim from '../../AddUpdateJob/CommonComponents/Sim';
import { JOBSTATUS, JOBTYPES } from '../../constants';
import BasicInformation from '../DefaultViews/BasicInformation';
import DescriptionsCombiner from '../DefaultViews/DescriptionsCombiner';
import DeviceRender from '../DefaultViews/DeviceRender';
import MissingWON from '../DefaultViews/MissingWON';
const { TODO, DOING, MISSINGWON, DONE, CANCELLED, ANNULLED, PROFORMA, INVOICED } = JOBSTATUS;
const DescriptionItem = Descriptions.Item;

let jobMessages = getJobMessages();

const messages = {
	...jobMessages,
};

class Installation extends React.Component {
	componentDidUpdate(prevProps) {
		const { isUpdate, saveFields, getField } = this.props;
		if (isUpdate !== prevProps.isUpdate && isUpdate) {
			const description = getField('gps.description');
			const sim = getField('gps.sim');
			const icon = getField('gps.icon');
			const deviceLease = getField('gps.deviceLease') === undefined ? false : true;
			saveFields({ description, sim, icon, deviceLease });
		}
	}

	getIntl = (str, values = {}) => this.props.intl.formatMessage({ ...messages[str] }, values);

	renderDefaultTodo = () => {
		const { getField } = this.props;
		return <BasicInformation getField={getField} />;
	};

	renderChargeType = () => {
		const { props, getIntl } = this;
		const { getField } = props;
		const embolden = (type) => (
			<Descriptions layout="vertical" size="small" bordered column={1}>
				<DescriptionItem label={getIntl('jobTypeInformation', { type: getIntl(JOBTYPES.INSTALLATION.intl) })}>
					<Embolden header={getIntl('chargeType')} value={getIntl(type)} row />
				</DescriptionItem>
			</Descriptions>
		);
		const chargeType = getField('invoiceInfo.chargeType');
		switch (chargeType) {
			case 1:
				return embolden('bought');
			case 2:
				return embolden('leased');
			default:
				return embolden('doesNotHave');
		}
	};

	renderTodo = () => {
		const { renderDefaultTodo, renderChargeType } = this;
		return (
			<DescriptionsCombiner>
				{renderDefaultTodo()}
				{renderChargeType()}
			</DescriptionsCombiner>
		);
	};

	renderMissingWON = () => {
		const { props, renderDone } = this;
		const { form, jobId } = props;
		return <MissingWON form={form} jobId={jobId} renderInfo={renderDone} />;
	};

	renderDevice = () => {
		const device = this.props.getField('gps');
		if (device) return <DeviceRender device={device} />;
	};

	renderDone = () => {
		const { renderDefaultTodo, renderChargeType, renderDevice } = this;
		return (
			<DescriptionsCombiner>
				{renderDefaultTodo()}
				{renderChargeType()}
				{renderDevice()}
			</DescriptionsCombiner>
		);
	};

	renderDeviceSelector = () => {
		const { form, saveFields, getField, isUpdate } = this.props;
		const { resetFields } = form;
		const save = (gps) => {
			const description = getNestedValue('description', gps);
			const sim = getNestedValue('sim', gps);
			const icon = getNestedValue('icon', gps);
			saveFields({ gps, description, sim, icon });
			resetFields(['description', 'sim', 'icon']);
		};
		const gps = getField('gps');
		const clientId = getField('client.clientId');
		return (
			<Device
				form={form}
				search={(deviceName) => SearchAvailableDevices(deviceName, 10)}
				device={gps}
				disabled={clientId === undefined || isUpdate}
				onChange={save}
				displayInfo={false}
			/>
		);
	};

	renderLeasedOption = () => {
		const { form, saveFields, getField } = this.props;
		const save = (deviceLease) => saveFields({ deviceLease });
		const deviceLease = getField('deviceLease');
		const clientId = getField('client.clientId');
		return <DeviceLease form={form} deviceLease={deviceLease} onChange={save} disabled={clientId === undefined} />;
	};

	renderSimSelector = () => {
		const { form, saveFields, getField } = this.props;
		const save = (sim) => saveFields({ sim });
		const sim = getField('sim');
		const clientId = getField('client.clientId');
		const assignedSim = getField('gps.sim');
		return (
			<Sim
				form={form}
				search={(simName) => SearchAvailableSimCards(simName, 10)}
				sim={sim}
				disabled={clientId === undefined}
				onChange={save}
				otherIncludedSims={assignedSim}
			/>
		);
	};

	renderIconPicker = () => {
		const { form, saveFields, getField } = this.props;
		const save = (icon) => saveFields({ icon });
		const icon = getField('icon.id');
		const clientId = getField('client.id');
		return <Icon form={form} icon={icon} disabled={clientId === undefined} onChange={save} />;
	};

	renderDescription = () => {
		const { form, saveFields, getField } = this.props;
		const save = (description) => saveFields({ description });
		const description = getField('description');
		const clientId = getField('client.id');
		return <Description form={form} description={description} disabled={clientId === undefined} onChange={save} />;
	};

	renderDeviceAccessories = () => {
		const { form, saveFields, getField, isUpdate } = this.props;
		return (
			<DeviceAccessoriesIntermediator
				form={form}
				isUpdate={isUpdate}
				getField={getField}
				saveFields={saveFields}
			/>
		);
	};

	renderDoing = () => {
		const {
			renderTodo,
			renderDeviceSelector,
			renderLeasedOption,
			renderSimSelector,
			renderIconPicker,
			renderDescription,
			renderDeviceAccessories,
		} = this;
		return (
			<div>
				{renderTodo()}
				{renderDeviceSelector()}
				{renderLeasedOption()}
				{renderSimSelector()}
				{renderIconPicker()}
				{renderDescription()}
				{renderDeviceAccessories()}
			</div>
		);
	};

	renderBasedOnStatus = () => {
		const { props, getIntl, renderTodo, renderMissingWON, renderDone, renderDoing } = this;
		const { getField, isUpdate } = props;
		if (isUpdate) return renderDoing();
		const status = getField('status');
		switch (status) {
			case TODO.id:
			case CANCELLED.id:
			case ANNULLED.id:
				return renderTodo();
			case DOING.id:
				return renderDoing();
			case INVOICED.id:
			case PROFORMA.id:
			case DONE.id:
				return renderDone();
			case MISSINGWON.id:
				return renderMissingWON();
			default:
				return <div>{getIntl('noStatusFormForType')}</div>;
		}
	};

	render() {
		return this.renderBasedOnStatus();
	}
}

Installation.defaultProps = {
	isUpdate: false,
};

Installation.propTypes = {
	intl: PropTypes.object.isRequired,
	form: PropTypes.object.isRequired,
	saveFields: PropTypes.func.isRequired,
	getField: PropTypes.func.isRequired,
	isUpdate: PropTypes.bool.isRequired,
	jobId: PropTypes.number.isRequired,
};

export default injectIntl(Installation);
